/**
 * The one sentence the shared table says on its own: what an empty table means
 * when the read behind it failed.
 *
 * 🔴 Until 2026-10-20 `ui/Table.tsx` printed the screen's `emptyMessage` whenever
 * `data` was empty and nothing was loading — on a failed read too, so ten tables on
 * nine screens said «Nothing synced yet», «TikTok lists no campaigns under this ad
 * account», «This campaign has no ad groups», «No agents yet» over a 502 or a 403.
 * Two of them (Agents, Proxies) had no banner above the table either, so the
 * failure was invisible. Found in twads first (spa-review #7, twads#162) and
 * measured here line by line before carrying: the table was byte-identical. The
 * sentence lives here, where a runner reads it; the table only chooses it when the
 * screen says the read failed.
 */
export const NOT_READ =
	"Not read: this list could not be read, so an empty table here is not an empty list.";

/**
 * 🔴 The one decision: what the empty row says. `ui/Table.tsx` renders this and
 * decides nothing itself, so both sides are a function a runner calls — a failed
 * read says NOT_READ whatever the screen's sentence is, and a successful empty read
 * says the screen's sentence and never NOT_READ.
 */
export function emptyCellText(failed: boolean, emptyMessage: string): string {
	return failed ? NOT_READ : emptyMessage;
}
